import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation, } from 'react-router';
import { selectAccessToken, selectUserDepartmentCode, } from '../../../features/auth/auth-slice';

interface Props {
    allowedDepartmentCode: string[];
}

export default function RequiredAuth({ allowedDepartmentCode = [], }: Props) {

    const token = useSelector(selectAccessToken);
    const userDepartmentCode = useSelector(selectUserDepartmentCode);
    const location = useLocation();

    /* * User is not authenticated. */
    if (!token) {
        return (
            <Navigate to="/login" state={{ from: location }} replace/>
        );
    }

    /** User is authenticated but doesn't have permission for this route. */
    if (allowedDepartmentCode.length > 0 &&!allowedDepartmentCode.includes(userDepartmentCode ?? '')) {
        return (
            <Navigate to="/unauthorized" state={{ from: location }} replace/>
        );
    }

    /** User is authenticated and authorized.*/
    return <Outlet />;
}
